import '../../table.less';

// import { CoreHelper, LoggerHelper } from '@helpers';
// import WithCoreProps from '../../../../../hocs/withCoreProps';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { TableRow } from '../../../tableRow';
import { TableAppearance, Row, ColType } from '../../types';
import { TableRowAppearances } from '../../../tableRow/types';
import { LoggerHelper, CoreHelper, TranslationProps, WithCoreProps } from 'ff-shared-components-core';
// import { TranslationProps } from '@i18n';

export interface PrimaryTableProps {
	appearance?: TableAppearance;
	/**sets the header values */
	headers?: string[];
	/**sets the row values */
	rows?: Row[];
	/**sets an array of widths to render the table, different columns can have different widths */
	columnsWidth?: ColType[];
	/**Sets a checkbox prefix*/
	withCheckbox?: boolean;
	/**Sets a empty column at the end of table*/
	withEmptySpaceSuffix?: boolean;
	/**Sets a icon column at the end of table*/
	withDownloadableSuffix?: boolean;
	/**Sets a suffix for the table row */
	withSuffix?: boolean;
	/**Sets an image  prefix for the row */
	rowImage?: string;
	/**Sets an image prefix for the table row */
	withImage?: boolean;
	/**set a base path to redirect on more details click */
	pathToRedirect?: string;
	/**Set the checkbox check*/
	isCheckboxChecked?: boolean;
	/**Sets a message in case there is no data to show */
	noDataMessage?: string;
	/**flag for error message */
	hasError?: boolean;
	/**Sets an error message in case something went wrong*/
	errorMessage?: string;
	/**defines max rows selected at once to be 3 */
	lockAtThreeSelectedRows?: boolean;
	/**Sets a suffix name to be shown on mobile */
	suffixName?: string;
	/** serves the purpose of catching the current selected row */
	onChange?: (items: Row[]) => void;
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
}

type Props = PrimaryTableProps & RouteComponentProps & TranslationProps;

class PrimaryTableComponent extends React.PureComponent<Props> {
	selectedRows: Row[] = [];
	// eslint-disable-next-line sonarjs/cognitive-complexity
	render(): React.ReactNode {
		const {
			headers,
			rows,
			withCheckbox,
			withImage,
			pathToRedirect,
			withSuffix,
			withEmptySpaceSuffix,
			withDownloadableSuffix,
			columnsWidth,
			t,
			noDataMessage = t<string>('table.noData'),
			errorMessage,
			hasError,
			onDetailsClick,
			suffixName,
		} = this.props;
		return (
			<>
				<div className="ds-table table-appearance-1">
					<ul className="ds-table-cell-header">
						<li>
							{headers &&
								headers.map(
									(h: string, index: number): JSX.Element => (
										<div
											key={CoreHelper.guid() || index}
											className={`flex-column ${
												columnsWidth && columnsWidth[index] === ColType.big
													? 'table-big-cell'
													: ''
											}${
												columnsWidth && columnsWidth[index] === ColType.normal
													? 'table-normal-cell'
													: ''
											}
											${columnsWidth && columnsWidth[index] === ColType.small ? 'table-small-cell' : ''}
											${columnsWidth && columnsWidth[index] === ColType.extraBig ? 'table-extra-big-cell' : ''}
											${columnsWidth && columnsWidth[index] === ColType.currency ? 'table-normal-currency-cell' : ''}`}
										>
											<span>{h}</span>
										</div>
									)
								)}
							{withSuffix && <div className="flex-column table-small-cell"></div>}
							{withDownloadableSuffix && <div className="flex-column table-small-cell"></div>}
							{withEmptySpaceSuffix && <div className="flex-column table-small-cell"></div>}
						</li>
					</ul>
					<div className="ds-table-body">
						<ul>
							{rows && rows.length !== 0 ? (
								rows.map(
									(row: Row, index: number): JSX.Element => (
										<TableRow
											onClick={(): void => {
												this.handleOnClick(row);
											}}
											suffixName={suffixName}
											columnsWidth={columnsWidth}
											withSuffix={withSuffix}
											withEmptySpaceSuffix={withEmptySpaceSuffix}
											rowId={row.id}
											row={row}
											pathToRedirect={pathToRedirect}
											key={CoreHelper.guid() || index}
											withImage={withImage}
											rowImage={row.image}
											mobileImage={row.mobileImage}
											withCheckbox={withCheckbox}
											columns={row.columns}
											isBold={row.isBold}
											onDetailsClick={onDetailsClick}
											isSelected={row.isSelected}
											isDownloadable={row.isDownloadable}
											withDownloadableSuffix={withDownloadableSuffix}
											appearance={TableRowAppearances.dynamic}
										></TableRow>
									)
								)
							) : (
								<li className="ds-table-cell">
									<div className="ds-table-cell-detail" style={{ width: '100%' }}>
										{hasError && !errorMessage ? noDataMessage : errorMessage}
									</div>
								</li>
							)}
						</ul>
					</div>
				</div>
			</>
		);
	}

	private readonly handleOnClick = (selectedRow: Row): void => {
		const { onChange, lockAtThreeSelectedRows } = this.props;

		if (this.selectedRows.find(s => s.id === selectedRow.id)) {
			this.selectedRows.splice(
				this.selectedRows.findIndex(x => x.id === selectedRow.id),
				1
			);
		} else {
			// TO DO -> Remove , not optimized , this code will be removed when the pending transactions services change
			if (lockAtThreeSelectedRows) {
				if (this.selectedRows.length < 3) {
					selectedRow.isSelected = true;

					this.selectedRows.push(selectedRow);
				}
			} else {
				// Maintain just this piece of code later
				selectedRow.isSelected = true;

				this.selectedRows.push(selectedRow);
			}
		}

		onChange && onChange(this.selectedRows);
		LoggerHelper.log('Primary table > selected rows', this.selectedRows);
	};
}

export const PrimaryTable = WithCoreProps<PrimaryTableProps>(withRouter(PrimaryTableComponent));
